


export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "port" */ "../views/login")
    },
    {
        path: '/reset',
        name: 'reset',
        component: () => import(/* webpackChunkName: "port" */ "../views/reset")
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "port" */ "../views/register")
    },
    {
        path: '/verify',
        name: 'verify',
        component: () => import(/* webpackChunkName: "port" */ "../views/verify")
    },
    {
        path: '/privacy',
        name: '/privacy',
        component: () => import(/* webpackChunkName: "port" */"../views/privacy")
    },
    {
        path: "/",
        redirect: { name: "panel" }
    },
];